module.exports = __webpack_public_path__ + "static/media/Maropost-Logo-Light-H.32881440.svg";